import { render } from "./Freezer.vue?vue&type=template&id=2538d723&scoped=true"
import script from "./Freezer.vue?vue&type=script&lang=js"
export * from "./Freezer.vue?vue&type=script&lang=js"

import "./Freezer.vue?vue&type=style&index=0&id=2538d723&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2538d723"]])

export default __exports__